import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SsoElement } from './sso-base.js';

/**
 * `<sso-spinner>` — small accessible loading indicator.
 * Set `aria-label` on the host for a meaningful announcement.
 */
@customElement('sso-spinner')
export class SsoSpinner extends SsoElement {
  static override styles = [
    SsoElement.styles,
    css`
      :host {
        display: grid;
        place-items: center;
        padding: var(--sso-space-lg);
      }
      .ring {
        width: 2rem;
        height: 2rem;
        border: 3px solid color-mix(in srgb, var(--sso-color-brand) 30%, transparent);
        border-top-color: var(--sso-color-brand);
        border-radius: 50%;
        animation: spin 0.8s linear infinite;
      }
      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    `,
  ];

  @property({ attribute: 'aria-label' }) ariaLabelText = 'Loading';

  override render() {
    return html`<div class="ring" role="status" aria-label=${this.ariaLabelText}></div>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sso-spinner': SsoSpinner;
  }
}
